import ModalBase from './ModalBase';
import GlowCard from '../ui/GlowCard';

interface Props { open: boolean; onClose: () => void; }

export default function HowToModal(props: Props) {
  const goFair = () => { try { (window as any).openModal?.('provably-fair'); } catch {} };
  return (
    <ModalBase id="howto-solid" title="How To Play" open={props.open} onClose={props.onClose} size="lg">
      <div class="mp-howto mp-howto-new">
        <div>
          <span class="mp-chip mp-chip-overview">Quick Overview</span>
        </div>

        <GlowCard>
          <div class="mp-card-head"><span class="mp-card-ico">🚀</span><h3 class="mp-card-title">Crash, but futuristic</h3></div>
          <p class="mp-card-text">Place your bet, watch the multiplier climb as the rocket ascends, and cash out before it crashes to lock in your win.</p>
        </GlowCard>

        <div class="mp-steps-grid">
          <GlowCard>
            <div class="mp-step">
              <div class="mp-step-num">1</div>
              <div class="mp-step-body">
                <div class="mp-step-title">Place your bet</div>
                <div class="mp-step-text">Enter an amount during BET TIME. You can enable Auto Bet.</div>
              </div>
            </div>
          </GlowCard>
          <GlowCard>
            <div class="mp-step">
              <div class="mp-step-num">2</div>
              <div class="mp-step-body">
                <div class="mp-step-title">Watch the rocket</div>
                <div class="mp-step-text">The multiplier increases in real-time after launch.</div>
              </div>
            </div>
          </GlowCard>
          <GlowCard>
            <div class="mp-step">
              <div class="mp-step-num">3</div>
              <div class="mp-step-body">
                <div class="mp-step-title">Cash out in time</div>
                <div class="mp-step-text">Click before crash. Your payout = Bet × Multiplier.</div>
              </div>
            </div>
          </GlowCard>
        </div>

        <GlowCard>
          <div class="mp-card-head"><span class="mp-card-ico">🧪</span><h3 class="mp-card-title">Example</h3></div>
          <p class="mp-example">Bet <strong>1.00</strong> | Cash Out @ <strong>3.00x</strong> → Win = <strong class="mp-gradient-number">3.00</strong></p>
        </GlowCard>

        <GlowCard>
          <div class="mp-card-head"><span class="mp-card-ico">💡</span><h3 class="mp-card-title">Tips & Strategy</h3></div>
          <ul class="mp-tips">
            <li><span class="tip-ico">🛡️</span> Consider safer cashout targets to protect your bankroll.</li>
            <li><span class="tip-ico">🔁</span> Use Auto Bet for repeating strategies across rounds.</li>
            <li><span class="tip-ico">📉</span> Avoid chasing losses. Stay consistent.</li>
          </ul>
        </GlowCard>

        <div class="mp-howto-divider" />

        <div class="mp-howto-footer">
          <button class="mp-chip" onClick={goFair}>Learn About Fairness →</button>
        </div>
      </div>
    </ModalBase>
  );
}
